import { useSelector } from 'react-redux';
import * as lookups from 'modules/api/lookups';
import { cancelFunctions } from 'utils/cancelFunctions';
import { CodeNameModel } from 'components/common/types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import usePendoTracking from 'customHooks/usePendoTracking';
import { Store } from 'components/common/types/Store.types';
import { FilterMultiDealIdProps } from './FilterDealMultiId.types';

const FilterDealMultiId = ({
  changeFilters,
  dealIds,
  isDisabled,
  selectedMarket,
}: FilterMultiDealIdProps): React.ReactElement => {
  const { getPendoDataId } = usePendoTracking(window.location.pathname);
  const environmentId = useSelector((state: Store) => state.environment.environmentId);

  const onLoadLookupData: AsyncSelectLoadDataHandler<CodeNameModel> = async (dropdownName, query) => {
    try {
      if (query.length < 2) {
        return [];
      }

      return await lookups.getCreativeAdminDealIdLookupData(
        cancelFunctions,
        selectedMarket ? selectedMarket.code : environmentId,
        query,
      );
    } catch (error) {
      return [];
    }
  };

  return (
    <AsyncSelect
      dataTestId="campaign-filter"
      name="campaignIds"
      loadData={onLoadLookupData}
      selectedValue={dealIds}
      placeholder="Campaign ID"
      onSelect={(_: string, value: CodeNameModel[]) =>
        changeFilters({
          dealIds: value,
        })
      }
      multiple
      isDisabled={isDisabled}
      dataPendoId={getPendoDataId('Campaign ID filter')}
    />
  );
};

export default FilterDealMultiId;
